import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'SectionCta',
};

interface ContentProps {
  first_image: { [key: string]: any };
  second_image: { [key: string]: any };
}

interface Props {
  content: ContentProps;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    content: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})